(() => {
  const ARROW_RIGHT_SVG =
    '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4 1L10 7L4 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function switchTab(root, index) {
    const tabs = root.querySelectorAll('.faq-with-category__tab');
    const panels = root.querySelectorAll('.faq-with-category__panel');

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle('active', i === index);
    });

    const activePanel = panels[index];
    if (activePanel) {
      resetPanelPagination(activePanel, 1);
    }
  }

  function setAnswerHeight(answer, open) {
    const content = answer.querySelector('.faq-with-category__answer-content');
    if (!content) return;

    if (open) {
      answer.style.height = `${content.offsetHeight}px`;
      answer.classList.add('faq-with-category__answer--open');
    } else {
      answer.style.height = '0';
      answer.classList.remove('faq-with-category__answer--open');
    }
  }

  function initAccordion(panel) {
    const questions = panel.querySelectorAll('.faq-with-category__question');

    questions.forEach((question) => {
      if (question.dataset.faqAccordionInit === 'true') return;

      question.addEventListener('click', () => {
        const answer = question.nextElementSibling;
        const isExpanded = question.getAttribute('aria-expanded') === 'true';
        question.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        setAnswerHeight(answer, !isExpanded);
      });

      question.dataset.faqAccordionInit = 'true';
    });

    let firstVisibleOpened = false;

    questions.forEach((question) => {
      const answer = question.nextElementSibling;
      const item = question.closest('.faq-with-category__item');
      if (item && item.hidden) {
        question.setAttribute('aria-expanded', 'false');
        setAnswerHeight(answer, false);
        return;
      }

      const isOpen = !firstVisibleOpened;
      if (isOpen) firstVisibleOpened = true;
      question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      setAnswerHeight(answer, isOpen);
    });
  }

  function buildPaginationNav(panel, totalPages, currentPage, onPageChange) {
    const nav = panel.querySelector('.faq-with-category__pagination');
    if (!nav) return;

    nav.innerHTML = '';
    nav.hidden = totalPages <= 1;

    if (totalPages <= 1) return;

    const list = document.createElement('ul');
    list.className = 'faq-with-category__pagination-list';
    list.setAttribute('role', 'list');

    const prevButton = document.createElement('button');
    prevButton.type = 'button';
    prevButton.className = 'faq-with-category__pagination-item faq-with-category__pagination-item--arrow faq-with-category__pagination-item--prev';
    prevButton.innerHTML = ARROW_RIGHT_SVG;
    prevButton.setAttribute('aria-label', 'Previous page');
    prevButton.disabled = currentPage === 1;
    prevButton.addEventListener('click', () => onPageChange(currentPage - 1));
    list.appendChild(document.createElement('li')).appendChild(prevButton);

    for (let page = 1; page <= totalPages; page += 1) {
      const li = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'faq-with-category__pagination-item';
      button.textContent = String(page);
      button.setAttribute('aria-label', `Page ${page}`);

      if (page === currentPage) {
        button.classList.add('faq-with-category__pagination-item--current');
        button.setAttribute('aria-current', 'page');
        button.disabled = true;
      } else {
        button.addEventListener('click', () => onPageChange(page));
      }

      li.appendChild(button);
      list.appendChild(li);
    }

    const nextLi = document.createElement('li');
    const nextButton = document.createElement('button');
    nextButton.type = 'button';
    nextButton.className = 'faq-with-category__pagination-item faq-with-category__pagination-item--arrow faq-with-category__pagination-item--next';
    nextButton.innerHTML = ARROW_RIGHT_SVG;
    nextButton.setAttribute('aria-label', 'Next page');
    nextButton.disabled = currentPage === totalPages;
    nextButton.addEventListener('click', () => onPageChange(currentPage + 1));
    nextLi.appendChild(nextButton);
    list.appendChild(nextLi);

    nav.appendChild(list);
  }

  function showPanelPage(panel, page, itemsPerPage) {
    const items = panel.querySelectorAll('.faq-with-category__item');
    const totalPages = Math.max(1, Math.ceil(items.length / itemsPerPage));

    const safePage = Math.min(Math.max(page, 1), totalPages);

    items.forEach((item, index) => {
      const itemPage = Math.floor(index / itemsPerPage) + 1;
      item.hidden = itemPage !== safePage;
    });

    initAccordion(panel);

    buildPaginationNav(panel, totalPages, safePage, (nextPage) => {
      showPanelPage(panel, nextPage, itemsPerPage);
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    panel.dataset.currentPage = String(safePage);
  }

  function resetPanelPagination(panel, page) {
    const root = panel.closest('.faq-with-category');
    const itemsPerPage = parseInt(root?.dataset.itemsPerPage || '10', 10);
    showPanelPage(panel, page, itemsPerPage);
  }

  function initPanelPagination(panel) {
    resetPanelPagination(panel, 1);
  }

  function initTabs(root) {
    const tabs = root.querySelectorAll('.faq-with-category__tab');
    const panels = root.querySelectorAll('.faq-with-category__panel');

    if (panels.length === 0) return;

    panels.forEach((panel, index) => {
      panel.classList.toggle('active', index === 0);
      initPanelPagination(panel);
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => switchTab(root, index));

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        switchTab(root, nextIndex);
      });
    });
  }

  function initResize(root) {
    if (root.dataset.faqResizeInit === 'true') return;

    window.addEventListener('resize', () => {
      root.querySelectorAll('.faq-with-category__panel.active .faq-with-category__question[aria-expanded="true"]').forEach((question) => {
        const answer = question.nextElementSibling;
        setAnswerHeight(answer, true);
      });
    });

    root.dataset.faqResizeInit = 'true';
  }

  function init(root) {
    if (!root || root.dataset.faqWithCategoryInit === 'true') return;

    root.classList.add('faq-with-category--initialized');
    initTabs(root);
    initResize(root);
    root.dataset.faqWithCategoryInit = 'true';
  }

  function initAll() {
    document.querySelectorAll('.faq-with-category').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.faq-with-category');
    if (root) {
      delete root.dataset.faqWithCategoryInit;
      delete root.dataset.faqResizeInit;
      root.querySelectorAll('[data-faq-accordion-init]').forEach((el) => {
        delete el.dataset.faqAccordionInit;
      });
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('.faq-with-category');
    if (root) {
      delete root.dataset.faqWithCategoryInit;
      delete root.dataset.faqResizeInit;
    }
  });
})();
